import { useToast } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import { customNotificationList } from 'api/auth.api';

const getErrorMessage = (error, fallback) => {
  const msg = error?.response?.data?.message;
  if (typeof msg === 'string') return msg;
  if (typeof msg === 'object' && msg?.message) return msg.message;
  return fallback;
};

export const useCustomNotificationList = (page, searchString) => {
  const toast = useToast();

  const { data, isLoading, isFetching } = useQuery({
    queryKey: ['customNotificationList', page, searchString],
    queryFn: () =>
      customNotificationList({
        page,
        searchString,
      }),
    select: (res) => res?.data || {},
    onError: (error) => {
      toast({
        title: getErrorMessage(error, 'Failed to fetch list'),
        status: 'error',
      });
    },
  });

  return {
    customNotification: data?.result || [],
    totalPages: data?.totalPages || 1,
    isLoading: isLoading || isFetching,
  };
};
